<template>
  <transition name="fade-slow">
    <div v-if="displayFullscreenLoading && (loading || dataHasErrors)" class="vh-loading-screen">
      <div class="loading-logo">
        <img :src="shizenLogo" alt="">
      </div>
      <div class="loading-message">
        <div
          v-for="({ key, trParams }) in loadingItems"
          :key="key"
          class="loading-key"
        >
          <span v-if="dLoading[key].loading === VLS.FETCHING">
            {{ $t('message.VH_LOADING', trParams) }}
          </span>
          <span v-else-if="dLoading[key].loading === VLS.WORKING">
            {{ $t('message.VH_WORKING', trParams) }}
          </span>
          <span v-else-if="dLoading[key].loading === VLS.READY">
            {{ $t('message.VH_READY', trParams) }}
          </span>
          <span v-else>
            {{ $t('message.VH_ERROR', trParams) }}
          </span>
          <span class="icon">
            <Icon v-if="dLoading[key].loading === VLS.READY" class="ready">{{ tickMedium }}</Icon>
            <Icon v-else-if="dLoading[key].loading === VLS.ERROR" class="error">{{ closeMedium }}</Icon>
            <img
              v-else
              class="loading-key-logo"
              :src="shizenLogo"
              alt=""
            >
          </span>
        </div>
        <div v-if="finalizingLoading !== VLS.FETCHING && allReady" class="loading-key">
          <span>
            {{ $t('message.VH_FINALIZING') }}
          </span>
          <span class="icon">
            <Icon v-if="finalizingLoading === VLS.READY" class="ready">{{ tickMedium }}</Icon>
            <Icon v-else-if="finalizingLoading === VLS.ERROR" class="error">{{ closeMedium }}</Icon>
            <img
              v-else
              class="loading-key-logo"
              :src="shizenLogo"
              alt=""
            >
          </span>
        </div>
        <div v-else class="action-btn mt5" @click="$emit('refresh')">
          {{ this.$t('message.REFRESH') }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

// Vuex
import { createNamespacedHelpers } from 'vuex';
// Components
import Icon from '@/components/icon.vue';
// Utils
import { capitalizeFirstLetter, shizenLogo } from '@/utils/main';
import { VitalityCategory } from '@/utils/classes/VitalityCategory';
import { VitalityLoadingState } from '@/utils/classes/VitalityLoadingState';
import {
  closeMedium,
  tickMedium,
} from '@/assets/icons';

const VLS = VitalityLoadingState;

const { mapState, mapGetters } = createNamespacedHelpers('vitality');

export default {
  name: 'VHLoadingScreen',

  components: {
    Icon,
  },

  data() {
    return {
      VLS,
      shizenLogo,
      closeMedium,
      tickMedium,
    };
  },

  computed: {
    /** Array: Check refreshingWhat items exist in dLoading */
    loadingItems() {
      return VitalityCategory.all
        .filter(cat => !!this.dLoading[cat.key])
        .map((cat) => {
          const tr = this.$t(`message.VH_WHAT_${cat.key.toUpperCase()}`);
          return {
            ...cat,
            trParams: {
              what: tr,
              capWhat: capitalizeFirstLetter(tr),
            },
          };
        });
    },
    ...mapState({
      dLoading: state => state.loading || {},
      finalizingLoading: state => state.finalizingLoading === true,
      displayFullscreenLoading: state => state.displayFullscreenLoading,
    }),
    ...mapGetters([
      'loading',
      'dataHasErrors',
      'allReady',
    ]),
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.vh-loading-screen {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  // Above category panels
  z-index: 1;

  .loading-message {
    text-align: center;

    .loading-key {
      display: flex;
      align-items: center;

      > .icon {
        width: 2.3em;
        height: 2.3em;
        margin-left: 1em;
        background: #fff;
        padding: 0.3em;
        border-radius: 20px;
        box-sizing: border-box;

        img {
          width: 100%;
          display: block;

          &.loading-key-logo {
            animation: rotation 2s infinite linear;
          }
        }
        svg {
          height: auto;
          width: 80%;
          display: inline-block;
          vertical-align: middle;

          &.ready {
            color: $color-green-good;
          }
          &.error {
            color: $color-red-bad;
          }
        }
      }
    }
  }
  .loading-logo {
    width: 10%;
    max-width: 150px;
    margin-bottom: 20px;
    padding: 10px;
    border-radius: 500px;
    background: white;
    box-shadow: 0px 0px 10px white;

    img {
      animation: rotation 2s infinite linear;
      -webkit-animation: rotation 2s infinite linear;
      width: 100%;
      display: block;
    }
  }
}

</style>
